import {
	ButtonGroup, Pagination as ChakraPagination, IconButton,
	PaginationRootProps, PaginationPageChangeDetails, PaginationPageSizeChangeDetails,
} from '@chakra-ui/react';
import { LuChevronLeft, LuChevronRight } from 'react-icons/lu';

type Pagination = {
	page:     number
	pageSize: number
	total:    number
};

type PaginationProps = {
	pagination?:       Pagination
	onPageChange?:     (detail: PaginationPageChangeDetails) => void
	onPageSizeChange?: (detail: PaginationPageSizeChangeDetails) => void
} & Omit<PaginationRootProps, 'count' | 'onPageChange' | 'onPageSizeChange' | 'page' | 'pageSize'>;

export const Pagination = ({
	onPageChange, onPageSizeChange, pagination, ...props
}: PaginationProps) => {
	if (!pagination) return null;

	return (
		<ChakraPagination.Root
			count={pagination.total}
			onPageChange={onPageChange}
			onPageSizeChange={onPageSizeChange}
			page={pagination.page}
			pageSize={pagination.pageSize}
			siblingCount={0}
			{...props}
		>
			<ButtonGroup  size="sm" variant="outline" w="full">
				<ChakraPagination.PageText alignSelf="flex-end" flex="1" format="long" />
				<ChakraPagination.PrevTrigger asChild>
					<IconButton>
						<LuChevronLeft />
					</IconButton>
				</ChakraPagination.PrevTrigger>

				<ChakraPagination.Items
					render={page => (
						<IconButton variant={{ _selected: 'solid', base: 'outline' }}>
							{page.value}
						</IconButton>
					)}
				/>

				<ChakraPagination.NextTrigger asChild>
					<IconButton>
						<LuChevronRight />
					</IconButton>
				</ChakraPagination.NextTrigger>
			</ButtonGroup>
		</ChakraPagination.Root>
	);
};
